import Text from '@components/Text';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import { useRef } from 'react';

import CloseIcon from './CloseIcon';
import useBottomSheetEffect from './hooks/useBottomSheetEffect';
import useBottomSheetValues from './hooks/useBottomSheetValues';
import styles from './styles.module.scss';

function BottomSheets() {
    const { closeBottomSheet } = useBottomSheet();
    const { children, title } = useBottomSheetValues();
    const ref = useRef<HTMLDivElement>(null);
    useBottomSheetEffect(ref);
    return (
        <div className={`${styles.backdrop} ${styles.none} ${styles.hide}`}
            ref={ref}>
            <div className={styles.container}>
                <header className={styles.header}>
                    <Text size='lg' fontWeight='bold'>{title}</Text>
                    <CloseIcon onClick={closeBottomSheet}/>
                </header>
                {children}
            </div>
        </div>
    );
}

export default BottomSheets;
